(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-bundle-cart"]) return;
  try {
    
if(!customElements.get('bb-kit-cart')) customElements.define('bb-kit-cart',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.abort=new AbortController();const signal=this.abort.signal;
    this.querySelectorAll('[data-cart-quantity]').forEach(control=>control.addEventListener('change',()=>this.updateLine(control.closest('[data-line-key]'),Math.max(1,Math.min(control.tagName==='SELECT'?2:99,Number(control.value)||1))),{signal}));
    this.querySelectorAll('[data-remove]').forEach(button=>button.addEventListener('click',()=>this.updateLine(button.closest('[data-line-key]'),0),{signal}));
    this.querySelector('form')?.addEventListener('submit',event=>{if(this.busy)event.preventDefault();},{signal});
    const mains=new Set([...this.querySelectorAll('[data-role="main"]')].map(el=>el.dataset.group));
    const orphans=[...this.querySelectorAll('[data-role="gift"]')].filter(el=>el.dataset.group&&!mains.has(el.dataset.group));
    if(orphans.length)this.removeOrphans(orphans);
  }
  disconnectedCallback(){this.abort?.abort();this.ready=false;}
  async request(url,payload){const response=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||this.dataset.error);return result;}
  setBusy(value){this.busy=value;this.setAttribute('aria-busy',String(value));this.querySelector('[name="checkout"]')?.toggleAttribute('disabled',value);}
  showError(error){const box=this.querySelector('[data-cart-error]');if(box){box.textContent=error.message||this.dataset.error;box.hidden=false;}}
  async removeOrphans(lines){this.setBusy(true);try{await this.request(this.dataset.updateUrl,{updates:Object.fromEntries(lines.map(line=>[line.dataset.lineKey,0]))});window.location.reload();}catch(error){this.showError(error);this.setBusy(false);}}
  async updateLine(line,quantity){
    if(this.busy)return;this.setBusy(true);const box=this.querySelector('[data-cart-error]');if(box)box.hidden=true;
    const previous=Number(line.dataset.quantity);const group=line.dataset.group;const isMain=line.dataset.role==='main';
    const linked=[...this.querySelectorAll('[data-role="gift"]')].filter(el=>el.dataset.group===group);
    const needsExtra=isMain&&quantity>=2&&!linked.some(el=>Number(el.dataset.min)>=2);
    let changed=false;
    try{
      if(needsExtra&&(!this.dataset.extraVariant||this.dataset.extraAvailable!=='true'))throw new Error(this.dataset.extraError);
      const updates={[line.dataset.lineKey]:quantity};
      if(isMain)linked.filter(el=>quantity===0||Number(el.dataset.min)>quantity).forEach(el=>updates[el.dataset.lineKey]=0);
      await this.request(this.dataset.updateUrl,{updates});changed=true;
      if(needsExtra)await this.request(this.dataset.addUrl,{items:[{id:Number(this.dataset.extraVariant),quantity:1,properties:{_bb_bundle:'enduro',_bb_group:group,_bb_role:'gift',_bb_min:'2','Included with':'Enduro rope set'}}]});
      window.location.reload();
    }catch(error){
      if(changed&&needsExtra){try{await this.request(this.dataset.updateUrl,{updates:{[line.dataset.lineKey]:previous}});}catch(rollbackError){this.showError(rollbackError);this.setBusy(false);return;}}
      const control=line.querySelector('[data-cart-quantity]');if(control)control.value=String(previous);
      this.showError(error);this.setBusy(false);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-enduro-landing"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('enduro-landing')) {
  customElements.define('enduro-landing', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      requestAnimationFrame(() => this.mount());
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.mediaObserver?.disconnect();
      this.querySelectorAll("video").forEach(video => video.pause());
      this.ready = false;
    }
    mount() {
      const signal = this.abort.signal;
      const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplay = this.dataset.autoplayMedia === 'true' && !motionPreference.matches;
      const videos = [...this.querySelectorAll('video.bb-clip')];
      const visibleVideos = new WeakSet();
      const pausedByVisitor = new WeakSet();
      const automaticPause = new WeakSet();
      videos.forEach(video => {
        video.addEventListener('pause', () => {
          if (automaticPause.has(video)) { automaticPause.delete(video); return; }
          if (visibleVideos.has(video)) pausedByVisitor.add(video);
        }, {signal});
        video.addEventListener('play', () => pausedByVisitor.delete(video), {signal});
      });
      this.mediaObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            visibleVideos.add(video);
            if (autoplay && !motionPreference.matches && !pausedByVisitor.has(video)) { video.muted = true; video.play().catch(() => {}); }
          } else {
            visibleVideos.delete(video);
            if (!video.paused) { automaticPause.add(video); video.pause(); }
          }
        });
      }, {threshold:[0,0.5]});
      videos.forEach(video => this.mediaObserver.observe(video));
      motionPreference.addEventListener('change', () => {
        if(motionPreference.matches) videos.forEach(video => video.pause());
      }, {signal});

      this.form = this.querySelector('.bb-product-form');
      this.addButton = this.querySelector('[data-add-button]');
      const panels = [...this.querySelectorAll('[data-panel]')];
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      const activate = index => {
        panels.forEach((panel,i) => { panel.hidden = i !== index; if(i !== index) panel.querySelectorAll('video').forEach(video => video.pause()); });
        thumbs.forEach((thumb,i) => { thumb.classList.toggle('is-active',i === index); thumb.setAttribute('aria-pressed', String(i === index)); });
        this.querySelector('[data-slide-number]').textContent = String(index + 1).padStart(2,'0');
      };
      thumbs.forEach((thumb,index) => {
        thumb.addEventListener('click', () => activate(index), {signal});
        thumb.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
          activate(next); thumbs[next].focus();
        }, {signal});
      });
      const choices = [...this.querySelectorAll('[data-offer]')];
      if (!choices.length || !this.form || !this.addButton) return;
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(cents / 100);
      const upgradeControl = this.querySelector('[data-second-set]');
      const selectChoice = choice => {
        choices.forEach(card => { const selected = card === choice; card.dataset.selected = String(selected); card.hidden = !selected; card.querySelector('input[name="quantity"]').checked = selected; });
        this.querySelectorAll('[data-set-total]').forEach(el => el.textContent = money(Number(choice.dataset.total)));
        const stickyPrice = this.querySelector('[data-sticky] .bb-sticky-inner > strong');
        if(stickyPrice) stickyPrice.textContent = money(Number(choice.dataset.total));
        if (upgradeControl) upgradeControl.checked = Number(choice.dataset.offer) === 2;
      };
      choices.forEach(choice => {
        const radio = choice.querySelector('input[name="quantity"]');
        radio.addEventListener('change',()=>selectChoice(choice),{signal});
        choice.querySelector('.bb-bundle-variant')?.addEventListener('click',()=>selectChoice(choice),{signal});
        choice.querySelectorAll('[data-gift-variant]').forEach(select=>select.addEventListener('change',()=>selectChoice(choice),{signal}));
      });
      selectChoice(choices.find(choice => choice.querySelector('input[name="quantity"]').checked) || choices[0]);
      upgradeControl?.addEventListener('change', () => {
        const target = choices.find(choice => Number(choice.dataset.offer) === (upgradeControl.checked ? 2 : 1));
        if (target) selectChoice(target);
      }, {signal});
      const singleChoice = choices.find(choice => Number(choice.dataset.offer) === 1);
      const doubleChoice = choices.find(choice => Number(choice.dataset.offer) === 2);
      const upgradePrice = this.querySelector('[data-upgrade-price]');
      if (singleChoice && doubleChoice && upgradePrice) upgradePrice.textContent = '+' + money(Number(doubleChoice.dataset.total) - Number(singleChoice.dataset.total));
      this.querySelectorAll('[data-gift-size]').forEach(button => button.addEventListener('click', () => {
        const slot = button.dataset.giftSlotTarget;
        const value = button.dataset.giftSize;
        choices.forEach(choice => {
          const row = choice.querySelector('[data-gift-slot="' + slot + '"]');
          const select = row?.querySelector('[data-gift-variant]');
          if (!select || !Array.from(select.options).some(option => option.value === value)) return;
          select.value = value;
          row.dataset.sizeChosen = 'true';
          choice.querySelectorAll('[data-gift-slot-target="' + slot + '"]').forEach(option => option.setAttribute('aria-pressed', String(option.dataset.giftSize === value)));
          choice.querySelectorAll('.bb-kit-size-row').forEach(sizeRow => {
            if (!sizeRow.querySelector('[data-gift-slot-target="' + slot + '"]')) return;
            sizeRow.querySelector('[data-selected-size]').textContent = button.dataset.sizeTitle;
            delete sizeRow.dataset.needsSelection;
          });
        });
        const currentError = this.querySelector('[data-form-error]');
        if(currentError) currentError.hidden = true;
      }, {signal}));

      const error = this.querySelector('[data-form-error]');
      this.form.addEventListener('submit', async event => {
        event.preventDefault();
        if(this.addButton.getAttribute('aria-busy') === 'true') return;
        error.hidden = true;
        const choice = choices.find(card => card.querySelector('input[name="quantity"]').checked);
        const mainId = this.form.querySelector('input[name="id"]').value;
        const gifts = [...choice.querySelectorAll('[data-gift-slot]')];
        const missingSize = gifts.find(row => row.dataset.sizeRequired === 'true' && row.dataset.sizeChosen !== 'true');
        if(missingSize){
          error.textContent = this.dataset.sizeError;
          error.hidden = false;
          const sizeButton = choice.querySelector('[data-gift-slot-target="' + missingSize.dataset.giftSlot + '"]');
          const sizeRow = sizeButton?.closest('.bb-kit-size-row');
          if(sizeRow) sizeRow.dataset.needsSelection = 'true';
          sizeButton?.focus();
          return;
        }

        if(!mainId || this.addButton.dataset.notAvailable || gifts.some(row => row.querySelector('select').selectedOptions[0]?.dataset.available !== 'true')){
          error.textContent = this.dataset.soon; error.hidden = false; return;
        }
        const group = 'enduro-' + (crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36));
        const items = [{id:Number(mainId),quantity:Number(choice.dataset.offer),properties:{_bb_bundle:'enduro',_bb_group:group,_bb_role:'main','Set':'Enduro cordless ropes'}}];
        gifts.forEach(row => items.push({id:Number(row.querySelector('select').value),quantity:1,properties:{_bb_bundle:'enduro',_bb_group:group,_bb_role:'gift',_bb_min:row.dataset.giftMin,'Included with':'Enduro rope set'}}));
        const label = this.addButton.querySelector('span');
        const original = label.textContent;
        this.addButton.setAttribute('aria-busy','true');label.textContent = this.dataset.adding;
        try {
          const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if(!response.ok || result.status) throw new Error(result.description || this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch(problem){error.textContent = problem.message || this.dataset.error;error.hidden = false;}
        finally{this.addButton.removeAttribute('aria-busy');label.textContent = original;}
      },{signal});
      const sticky = this.querySelector('[data-sticky]');
      this.querySelector('[data-sticky-add]').addEventListener('click', () => {
        this.querySelector('.bb-bundles').scrollIntoView({behavior:motionPreference.matches?'auto':'smooth',block:'start'});
      }, {signal});
      const purchase = this.querySelector('[data-purchase]');
      const title = this.querySelector('#enduro-title');
      this.observer = new IntersectionObserver(() => {
        const rect = purchase.getBoundingClientRect();
        const purchaseVisible = rect.top < window.innerHeight && rect.bottom > 0;
        sticky.hidden = title.getBoundingClientRect().bottom > 0 || purchaseVisible;
      }, {threshold:[0,1]});
      this.observer.observe(title);
      this.observer.observe(purchase);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
